import { Link } from '@tanstack/react-router'
import { FiChevronRight } from 'react-icons/fi'

export interface BreadcrumbItem {
  label: string
  route?: string // absent = page courante, non cliquable
}

interface BreadcrumbProps {
  items: Array<BreadcrumbItem>
}

export const Breadcrumb = ({ items }: BreadcrumbProps) => (
  <nav aria-label="Fil d'Ariane" className="mb-6">
    <ol className="flex items-center gap-2 text-sm text-gray-500">
      {items.map((item, index) => {
        const isLast = index === items.length - 1

        return (
          <li key={item.label} className="flex items-center gap-2">
            {index > 0 && (
              <FiChevronRight className="shrink-0" aria-hidden="true" />
            )}
            {item.route && !isLast ? (
              <Link
                to={item.route}
                className="hover:text-black-700 hover:underline"
              >
                {item.label}
              </Link>
            ) : (
              <span
                aria-current={isLast ? 'page' : undefined}
                className={isLast ? 'font-semibold text-black-900' : undefined}
              >
                {item.label}
              </span>
            )}
          </li>
        )
      })}
    </ol>
  </nav>
)
